import { NgModule, ModuleWithProviders } from '@angular/core';
import { NgxSummernoteCustomDirective } from './ngx-summernote.directive';
import { NgxSummernoteCustomViewDirective } from './ngx-summernote-view.directive';

@NgModule({
  declarations: [
    NgxSummernoteCustomDirective,
    NgxSummernoteCustomViewDirective
  ],
  exports: [
    NgxSummernoteCustomDirective,
    NgxSummernoteCustomViewDirective
  ]
})
export class NgxSummernoteCustomModule {
  public static forRoot(): ModuleWithProviders<NgxSummernoteCustomModule> {
    return {ngModule: NgxSummernoteCustomModule,  providers: []};
  }
}
